// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_service_intake_form".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "organization_service_intake_form" table (1:1 with a DB row, on the wire). */
export const organizationServiceIntakeFormAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    serviceId: z.string(),
    intakeFormId: z.string(),
    blocksBooking: z.boolean(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=organizationServiceIntakeForm.js.map